var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup163221(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 304,
    height: 151,
    viewBox: "0 0 304 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148113",
    "data-name": "Rectangle 148113",
    width: 304,
    height: 151,
    rx: 15,
    transform: "translate(0 -0.296)",
    fill: "#ec9859"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_727",
    x: 92.499,
    y: -194.5,
    width: 420,
    height: 420,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_729",
    x: -184.501,
    y: -51.5,
    width: 421,
    height: 421,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_728",
    x: 134.499,
    y: -105.5,
    width: 371,
    height: 372,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163221",
    "data-name": "Group 163221",
    transform: "translate(0 0.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active_Tab_Indicator",
    "data-name": "Active Tab Indicator",
    transform: "translate(0.227 0.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162446",
    "data-name": "Group 162446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147724",
    "data-name": "Rectangle 147724",
    width: 303.546,
    height: 149.401,
    rx: 15,
    fill: "#e99657"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_36",
    "data-name": "Mask Group 36",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162957",
    "data-name": "Group 162957",
    transform: "translate(-35.811 -46.953)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 35.81, 46.66)",
    filter: "url(#Ellipse_727)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_727-2",
    "data-name": "Ellipse 727",
    cx: 61.5,
    cy: 61.5,
    r: 61.5,
    transform: "translate(241 -47)",
    fill: "#db5a55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 35.81, 46.66)",
    filter: "url(#Ellipse_729)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_729-2",
    "data-name": "Ellipse 729",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(-36 96)",
    fill: "#db5a55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 35.81, 46.66)",
    filter: "url(#Ellipse_728)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_728-2",
    "data-name": "Ellipse 728",
    cx: 37,
    cy: 37.5,
    rx: 37,
    ry: 37.5,
    transform: "translate(283 42)",
    fill: "#ec9d5a"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163221);
export default __webpack_public_path__ + "static/media/Group 163221.3a2310121d59edbd4ddeb19c2ab0e67c.svg";
export { ForwardRef as ReactComponent };